import { COMES_FROM_ENROLL_STARTAPP, referrer } from './comesFromEnrollStartApp'
import enableSaveQuoteAgent from 'core/controllerPlans/enableSaveQuoteAgent'
import isSalesCenterAgent from 'utils/pivot/agent/isSalesCenterAgent'
import comparePlansFromAgent from './comparePlansFromAgent'
import { IS_AGENT } from 'core/constants/environment'
import removeElements from 'utils/DOM/removeElements'
import toggleClass from 'utils/DOM/toggleClass'
import curry from 'utils/functional/curry'
import forEach from 'utils/DOM/forEach'
import tooltip from 'core/DOM/tooltip'
import { preventOnCloseEvent } from 'core/services/onClose'
import clickEventName from 'utils/DOM/clickEventName'
import { redirectToSTM } from 'core/controllerPlansBTM/forbidBTM'
import initSmartly from 'core/initPage/absmartly'
import registerSnowplowListeners from './registerSnowplowListeners'

function hideLoading() {
  toggleClass(document.body, 'show-loading', false)
  removeElements('#page-loading')
}

function initDOM(state: Pivot.State): void {
  const { hcStorage, compareBTM } = state

  // Setup GTM and add userId to dataLayer
  window.dataLayerPushVariable({
    user_id: hcStorage.healthcareUserId
  })

  const smartlySDK = initSmartly()

  let disableBTM = 1
  if (smartlySDK) {
    disableBTM = smartlySDK.treatment('PH_BTM_REDIRECT')
  }

  redirectToSTM(compareBTM, disableBTM)

  toggleClass('.js-statistics-show', 'd-none', true)

  if (hcStorage.location.state_acronym === 'NE') {
    toggleClass(document.body, 'ne')
  }

  toggleClass(document.body, 'btm', compareBTM)

  if (IS_AGENT) {
    isSalesCenterAgent(hcStorage.agent_id).then(salesCenterAgent => {
      enableSaveQuoteAgent(() => {
        toggleClass('#email-quote-singular', 'd-sm-block', true)
      }, curry(comparePlansFromAgent)(salesCenterAgent))
    })
  }

  hideLoading()
  tooltip.init()

  $('body')
    .on(clickEventName, '.js-back-to', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.primaryButton', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '#footer-details-link', function () {
      preventOnCloseEvent()
    })

  toggleClass('#plan-switch__wrap', 'd-none', !state.planHasChanged)

  if (COMES_FROM_ENROLL_STARTAPP) {
    forEach('.js-back-to', backTo => {
      backTo.href = referrer
      const backToText = backTo.querySelector('.js-back-to-text')
      if (backToText) {
        backToText.textContent = 'Back to Your Plan'
      }
    })
  }

  registerSnowplowListeners()
}

export default initDOM
